import React from 'react';

import PlaceContextData from './PlaceContextData';

const PlaceContext = React.createContext<PlaceContextData | null>(null);

export default PlaceContext;
